<h5 class="header" id="line-items">
  {{'ISSUE-TEXT.LINE-ITEMS' | translate}}
</h5>
<div class="box-content">
  <div [formGroup]="lineItemForm" style="margin-bottom: -1rem;">
    <div class="table-responsive">
      <table class="table table-borderless" aria-describedby="line-items">
        <thead class="text-center">
          <tr>
            <th scope="col" style="width: 12%;">{{'ISSUE-TEXT.PRODUCT-ID'|translate}}</th>
            <th scope="col">{{'ISSUE-TEXT.DESCRIPTION'|translate}}</th>
            <th scope="col" style="width: 100px;">{{'ISSUE-TEXT.QTY'|translate}}</th>
            <th scope="col" style="width: 100px;">{{'ISSUE-TEXT.UNIT'|translate}}</th>
            <th scope="col" style="width: 12%;">{{'ISSUE-TEXT.UNIT-PRICE'|translate}}</th>
            <th scope="col" style="width: 12%;">{{'ISSUE-TEXT.VAT-TYPE'|translate}}</th>
            <th scope="col" style="width: 12%;">{{'ISSUE-TEXT.DISCOUNT'|translate}}</th>
            <th scope="col" style="width: 12%;">{{'ISSUE-TEXT.TOTAL'|translate}}</th>
          </tr>
        </thead>
        <tbody>
          <ng-container formArrayName="items">
            <ng-container *ngFor="let item of items.controls; let i=index">
              <ng-container [formGroupName]="i">
                <tr>
                  <td>
                    <input class="form-control" type="text" formControlName="productID">
                  </td>
                  <td>
                    <input class="form-control" type="text" formControlName="description">
                    <div *ngIf="getDescription(i).errors?.required && isSubmitted">
                      <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
                    </div>
                  </td>
                  <td>
                    <input class="form-control text-right" type="text" formControlName="quantity" mask="separator.0"
                      thousandSeparator=",">
                    <div *ngIf="getQuantity(i).errors?.required && isSubmitted">
                      <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
                    </div>
                  </td>
                  <td>
                    <input class="form-control text-right" type="text" formControlName="unit">
                  </td>
                  <td>
                    <input class="form-control text-right" type="text" formControlName="unitPrice" mask="separator.2"
                      thousandSeparator=",">
                    <div *ngIf="getUnitPrice(i).errors?.required && isSubmitted">
                      <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
                    </div>
                  </td>
                  <td>
                    <p-dropdown class="dv-dropdown" [options]="vats" formControlName="lineVAT">
                      </p-dropdown>
                  </td>
                  <td>
                    <input class="form-control text-right" type="text" formControlName="discount" mask="separator.2"
                      thousandSeparator=",">
                  </td>
                  <td class="text-right">
                    <div class="row align-items-center no-gutters">
                      <div class="col">
                        <p class="form-control m-0">{{ getTotal(i).toNumber() | currency:' ' }}</p>
                      </div>
                      <div class="col-auto p-l-5" *ngIf="i !==0 ">
                        <button class="ui-button bg-danger border-danger ui-button-icon-only"
                          (click)="removeItem(i)">
                          <em class="fa fa-trash-alt"></em>
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              </ng-container>
            </ng-container>
          </ng-container>
          <tr>
            <td colspan="8">
              <button class="ui-button ui-button-icon-only" (click)="addItem()">
                <em class="fa fa-plus"></em>
              </button>
              <span>
                {{'ISSUE-TEXT.ADD-ITEM'|translate}}
              </span>
            </td>
          </tr>
          <tr class="border-top">
            <td colspan="4">
              {{'ISSUE-TEXT.AMOUNT' | translate}} {{ amountText }}
            </td>
            <td colspan="3" class="text-right">
              {{'ISSUE-TEXT.SUB-TOTAL' | translate}}
            </td>
            <td class="text-right">
              {{ subTotal.toNumber() | currency:' ' }}
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <div class=" row">
                <div class="col-md-3">
                  {{'ISSUE-TEXT.REASON-OF-DISCOUNT' | translate}}
                </div>
                <div class="col-md-7">
                  <input class="form-control" type="text" formControlName="discountReason">
                </div>
              </div>
            </td>
            <td colspan="3" class="text-right">
              {{'ISSUE-TEXT.LINE-ITEM-DISCOUNT-TOTAL' | translate}}
            </td>
            <td class="text-right">
              {{ discountTotal.toNumber() | currency:' ' }}
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <div class=" row" *ngIf="isCreditNote || isDebitNote">
                <div class="col-md-4">
                  {{'ISSUE-TEXT.ORIGINAL-AMOUNT' | translate}}
                </div>
                <div class="col-md-4">
                  <input class="form-control text-right" type="text" formControlName="originalAmount" mask="separator.2"
                    thousandSeparator=",">
                  <ng-container *ngIf="originalAmount.errors?.required && isSubmitted">
                    <span class="text-danger">{{ 'ERROR.REQUIRED' | translate }}</span>
                  </ng-container>
                </div>
              </div>
            </td>
            <td colspan="4" style="padding: 0px;" >
              <table>
                <ng-container formArrayName="endBillDiscountList">
                  <ng-container *ngFor="let endBillDiscount of endBillDiscountList.controls; let i=index">
                    <ng-container [formGroupName]="i">
                      <tr>
                        <td class="col-md-9 text-right">
                          <div class="row no-gutters justify-content-end">
                            <div class="col-auto align-self-center">
                              {{'ISSUE-TEXT.END-BILL-DISCOUNT' | translate}}
                            </div>
                            <div class="col-auto">
                              <div style="width: 100px; margin-left: 10px;">
                                <p-dropdown class="dv-dropdown" [options]="vats" formControlName="typeDiscount" appendTo="body">
                                </p-dropdown>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td class="col-md-3">
                          <div class="row no-gutters justify-content-end align-self-center">
                            <div class="col-md-10 align-self-center pr-1">
                              <input class="form-control text-right" type="text" formControlName="endBillDiscount" mask="separator.2"
                              thousandSeparator=",">
                            </div>
                            <div class="col-md-2 align-self-center">
                              <button *ngIf="i==0" [ngClass]="isDisableAddDiscount ? 'disable':'ui-button'" (click)="!isDisableAddDiscount && addEndBillDiscount()">
                                <i class="fa fa-plus mx-1"></i>
                              </button>
                              <button *ngIf="i!==0" class="ui-button bg-danger border-danger" (click)="removeEndBillDiscount(i)">
                                <i class="fa fa-trash-alt mx-1"></i>
                              </button>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </table>
              <div *ngIf="nonVATAmount.isNegative() || vatAmount.isNegative() || vat0Amount.isNegative()" class="text-right text-danger">
                {{'ISSUE-TEXT.AMOUNT-ERROR' | translate}}
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <div class=" row" *ngIf="isCreditNote || isDebitNote">
                <div class="col-md-4">
                  {{'ISSUE-TEXT.ORIGINAL-VAT' | translate}}
                </div>
                <div class="col-md-4">
                  <input class="form-control text-right" type="text" formControlName="originalVAT" mask="separator.2"
                    thousandSeparator=",">
                  <ng-container *ngIf="originalVAT.errors?.required && isSubmitted">
                    <span class="text-danger">{{ 'ERROR.REQUIRED' | translate }}</span>
                  </ng-container>
                </div>
              </div>
            </td>
            <td colspan="3" class="text-right">
              {{'ISSUE-TEXT.BALANCE' | translate}}
            </td>
            <td class="text-right">
              {{ balance.toNumber() | currency:' ' }}
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <div class=" row" *ngIf="isCreditNote || isDebitNote">
                <div class="col-md-4">
                  {{'ISSUE-TEXT.NEW-AMOUNT' | translate}}
                </div>
                <div class="col-md-4">
                  <p class="form-control m-0 text-right">{{ correctAmount.toNumber() | currency:' ' }}</p>
                  <ng-container *ngIf="correctAmount < 0 && isSubmitted">
                    <span class="text-danger">{{ 'ERROR.INVALID' | translate }}</span>
                  </ng-container>
                </div>
              </div>
            </td>
          </tr>
          <tr class="border-top">
            <td colspan="7">
              <div class="row no-gutters justify-content-end">
                <div class="col-auto align-self-center">
                  {{'ISSUE-TEXT.VAT' | translate}}
                </div>
              </div>
            </td>
            <td class="text-right">
              <input class="form-control text-right" type="text" formControlName="vat" thousandSeparator="," mask="separator.2">
            </td>
          </tr>
          <tr>
            <td colspan="7" class="text-right">
              {{'ISSUE-TEXT.NET-TOTAL' | translate}}
            </td>
            <td class="text-right">
              {{ netTotal.toNumber() | currency:' ' }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /opt/app/src/app/features/document/document-issue/components/line-item-form/line-item-form.component.html